import React from 'react'

// Node Modules
import { DomElement } from 'html-react-parser'

// Components
import Title from 'components/xis/Title'

export default ({ children }:DomElement, params:any, options:any) => {
  const title = children && children[0].data

  const [subtitle] = title.split('::')

  return <Title title={subtitle} />
}